import React from "react";
import StickyHeadTable from "./StickyHeadTable";
import { isMobile } from "react-device-detect";
import dateFormat from "dateformat";
import RecordsBox from "./RecordsBox";
import PageWrapper from "./layout/PageWrapper";

const AdminForms = function (props) {
  const {
    forms: items,
    superUser,
    onEdit,
    canEdit,
    onRefreshData,
    onExportData,
    onDelete,
    search,
  } = props;

  const [itemsForSelection, setItemsForSelection] = React.useState([]);

  const handleItemsForSelectionChange = (items) => {
    setItemsForSelection(items);
  };

  const displayedColumnsInitial = [
    { id: "id", label: "#", minWidth: 50, align: "left" },
    { id: "name", label: "Form name", minWidth: 60 },
    { id: "usrFirstname", label: "Firstname", minWidth: 60 },
    { id: "usrLastname", label: "Lastname", minWidth: 60 },
    { id: "paymentStatus", label: "Payé", minWidth: 60 },
    { id: "created", label: "Created", minWidth: 60 },
    { id: "modified", label: "Modified", minWidth: 60 },
    { id: "action", label: "Actions", minWidth: isMobile ? 60 : 120 },
  ];

  const displayedColumns = superUser
    ? displayedColumnsInitial
    : displayedColumnsInitial;

  return (
    <PageWrapper>
      <RecordsBox items={items} itemsForSelection={itemsForSelection} />

      <StickyHeadTable
        search={search}
        canEdit={canEdit}
        superUser={superUser || true}
        filters={["id", "name"]}
        columns={
          isMobile
            ? displayedColumns.filter(
                (c) =>
                  c.id === "usrFirstname" ||
                  c.id === "usrLastname" ||
                  c.id === "paymentStatus" ||
                  c.id === "created" ||
                  c.id === "action"
              )
            : displayedColumns
        }
        data={(items || []).map((f) => ({
          id: f.id,
          name: f.name,
          usrFirstname: f.content.firstName,
          usrLastname: f.content.lastName,
          saleId: f.content.saleId,
          paymentStatus: f.saleId ? "Oui" : "Non",
          created: dateFormat(f.created, "mmm dS, H:MM"),
          modified: dateFormat(f.modified, "mmm dS, H:MM"),
        }))}
        onDelete={onDelete}
        onEdit={onEdit}
        onItemsForSelectionChange={handleItemsForSelectionChange}
        onRefreshData={onRefreshData}
        onExportData={onExportData}
        checkboxEnabled={true}
      />
    </PageWrapper>
  );
};

export default AdminForms;
